// local translations for the email client
// we needed a fast way to translate the email subject and body based on the language of the PDF

type tContext = Record<string, any>;

export const invoiceSubjectTranslations = {
  en: ({ name }: tContext) => `Invoice {{revenueNumber}} from ${name}`,
  fr: ({ name }: tContext) => `Facture {{revenueNumber}} de ${name}`,
  nl: ({ name }: tContext) => `Factuur {{revenueNumber}} van ${name}`,
  de: ({ name }: tContext) => `Rechnung {{revenueNumber}} von ${name}`,
};
export const creditNoteSubjectTranslations = {
  de: {
    en: ({ name }: tContext) =>
      `Cancellation invoice {{revenueNumber}} from ${name}`,
    fr: () => '',
    nl: () => '',
    de: ({ name }: tContext) => `Stornorechnung {{revenueNumber}} von ${name}`,
  },
  be: {
    en: ({ name }: tContext) => `Credit note {{revenueNumber}} from ${name}`,
    fr: ({ name }: tContext) => `Note de crédit {{revenueNumber}} de ${name}`,
    nl: ({ name }: tContext) => `Creditnota {{revenueNumber}} van ${name}`,
    de: () => '',
  },
};
export const invoiceBodyTranslations = {
  en: () =>
    `Dear client,\nPlease find attached our invoice for an amount of {{totalAmountInclVAT}}\nBest regards,\n{{fullname}}`,
  fr: () =>
    `Cher client,\nVeuillez trouver ci-dessous notre facture pour un montant de {{totalAmountInclVAT}}\nCordialement,\n{{fullname}}`,
  nl: () =>
    `Beste klant,\nHieronder vindt u mijn factuur voor een bedrag van {{totalAmountInclVAT}}\nMet vriendelijke groet,\n{{fullname}}`,
  de: () =>
    `Liebe Kundin, lieber Kunde,\nvielen Dank für Ihren Auftrag. Anbei erhalten Sie die Rechnung in Höhe von {{totalAmountInclVAT}}\nMit freundlichen Grüßen,\n{{fullname}}`,
};

export const quoteSubjectTranslations = {
  en: ({ name }: tContext) => `Quote {{quoteNumber}} from ${name}`,
  fr: ({ name }: tContext) => `Devis {{quoteNumber}} de ${name}`,
  nl: ({ name }: tContext) => `Offerte {{quoteNumber}} van ${name}`,
  de: ({ name }: tContext) => `Angebot {{quoteNumber}} von ${name}`,
};
export const quoteBodyTranslations = {
  en: () =>
    `Dear client,\nPlease find attached our quote for an amount of {{totalAmountInclVAT}}\nBest regards,\n{{fullname}}`,
  fr: () =>
    `Cher client,\nVeuillez trouver ci-dessous notre devis pour un montant de {{totalAmountInclVAT}}\nCordialement,\n{{fullname}}`,
  nl: () =>
    `Beste klant,\nHieronder vindt u mijn offerte voor een bedrag van {{totalAmountInclVAT}}\nMet vriendelijke groet,\n{{fullname}}`,
  de: () =>
    `Guten Tag,\nvielen Dank für Ihr Interesse. Anbei finden Sie ein Angebot in Höhe von {{totalAmountInclVAT}}\nMit freundlichen Grüßen,\n{{fullname}}`,
};

export const invoiceReminderSubjectTranslations = {
  en: () => `Payment reminder for invoice {{revenueNumber}}`,
  fr: () => 'Rappel de paiement pour la facture {{revenueNumber}}',
  nl: () => 'Herinnering voor factuur {{revenueNumber}}',
  de: () => 'Zahlungserinnerung für Rechnung {{revenueNumber}}',
};

export const invoiceReminderBodyTranslations = {
  en: () =>
    `Dear client,\nWe would like to remind you that payment for invoice {{revenueNumber}} is still outstanding. Kindly proceed with payment as soon as possible.\nWe attach the invoice to this reminder for your convenience.\nBest regards,\n{{fullname}}`,
  fr: () =>
    `Cher client,\nNous vous rappelons que le paiement de la facture {{revenueNumber}} n'a pas encore été effectué. Veuillez s'il vous plaît procéder au paiement dès que possible.\nNous joignons la facture à ce rappel pour votre convenance.\nBien à vous,\n{{fullname}}`,
  nl: () =>
    `Beste klant,\nGraag herinneren we u eraan dat de betaling voor factuur {{revenueNumber}} nog steeds openstaat. Gelieve de betaling zo snel mogelijk uit te voeren.\nU zult een kopie van de factuur terugvinden als bijlage van deze e-mail.\nMet vriendelijke groet,\n{{fullname}}`,
  de: () =>
    `Sehr geehrter Kunde,\nwir möchten Sie daran erinnern, dass die Zahlung für die Rechnung {{revenueNumber}} noch aussteht. Wir bitten Sie, die Zahlung so schnell wie möglich vorzunehmen.\nWir fügen dieser Erinnerung die Rechnung bei, um Ihnen die Arbeit zu erleichtern.\nMit freundlichen Grüßen\n{{fullname}}`,
};
